(() => {
  const html = document.documentElement;
  const intro = document.querySelector('[data-intro]');
  const phoneNoMotion = matchMedia('(max-width: 749px)').matches;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = document.body?.dataset.shopifyDesignMode === 'true';

  if (designMode) {
    intro?.remove();
    document.querySelectorAll('[data-reveal]').forEach((element) => element.classList.add('visible'));
    return;
  }

  if (intro && !html.classList.contains('intro-seen') && !reducedMotion) {
    html.classList.add('intro-play');
    try { sessionStorage.setItem('philistia-intro-seen', '1'); } catch (_error) { /* storage unavailable */ }
    setTimeout(() => intro.remove(), 3050);
  } else {
    intro?.remove();
  }

  if (phoneNoMotion) {
    html.classList.add('mobile-no-motion');
    document.querySelectorAll('[data-reveal]').forEach((element) => element.classList.add('visible'));
    return;
  }

  const selectors = '.pal-catalog,.curated-palestine,.tatreez-manifesto,.spice-story,.map-section,.heritage-finder,.story-chapter';
  document.querySelectorAll(selectors).forEach((element) => element.setAttribute('data-scroll-motion', ''));
  const ghost = document.querySelector('[data-brand-ghost]');
  const progress = document.querySelector('[data-scroll-progress] i');
  const sections = [...document.querySelectorAll('[data-scroll-motion]')];
  let productCards = [...document.querySelectorAll('[data-product-motion]')];
  const heroVisual = document.querySelector('[data-hero-visual]');
  let ticking = false;

  function motion() {
    const maximum = Math.max(1, document.documentElement.scrollHeight - innerHeight);
    const ratio = Math.min(1, Math.max(0, scrollY / maximum));
    progress?.style.setProperty('transform', `scaleX(${ratio})`);
    if (!reducedMotion && ghost) {
      ghost.style.setProperty('--ghost-y', `${Math.sin(ratio * Math.PI * 3) * 38}px`);
      ghost.style.setProperty('--ghost-r', `${ratio * 18 - 9}deg`);
      ghost.style.setProperty('--ghost-s', `${1 + ratio * 0.12}`);
    }
    if (!reducedMotion) {
      sections.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const sectionProgress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - innerHeight / 2) / innerHeight));
        element.style.setProperty('--section-progress', sectionProgress);
      });
      productCards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        if (rect.bottom < -120 || rect.top > innerHeight + 120) return;
        const cardProgress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - innerHeight / 2) / innerHeight));
        const direction = Number.parseFloat(card.style.getPropertyValue('--card-direction')) || 1;
        const mobile = innerWidth < 750;
        card.style.setProperty('--card-scroll-y', `${(-cardProgress * (mobile ? 18 : 46)).toFixed(2)}px`);
        card.style.setProperty('--card-scroll-x', `${(cardProgress * direction * (mobile ? 4 : 10)).toFixed(2)}px`);
        card.style.setProperty('--card-image-y', `${(cardProgress * (mobile ? 11 : 25)).toFixed(2)}px`);
        card.style.setProperty('--card-rotate', `${(cardProgress * direction * (mobile ? 0.16 : 0.42)).toFixed(3)}deg`);
      });
      if (heroVisual) {
        const rect = heroVisual.getBoundingClientRect();
        const heroProgress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - innerHeight / 2) / innerHeight));
        heroVisual.style.setProperty('--hero-scroll', heroProgress);
        heroVisual.style.setProperty('--hero-stone-y', `${(heroProgress * 9).toFixed(2)}px`);
        heroVisual.style.setProperty('--hero-horizon-y', `${(heroProgress * 17).toFixed(2)}px`);
      }
    }
    ticking = false;
  }
  addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(motion);
      ticking = true;
    }
  }, { passive: true });
  addEventListener('resize', () => {
    if (!ticking) {
      requestAnimationFrame(motion);
      ticking = true;
    }
  }, { passive: true });
  document.addEventListener('shopify:section:load', () => {
    productCards = [...document.querySelectorAll('[data-product-motion]')];
    motion();
  });
  document.addEventListener('philistia:wishlist-rendered', () => {
    productCards = [...document.querySelectorAll('[data-product-motion]')];
    motion();
  });
  motion();

  if (matchMedia('(pointer: fine) and (prefers-reduced-motion: no-preference)').matches) {
    document.querySelectorAll('.product-card').forEach((card) => {
      card.addEventListener('mousemove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--tilt-x', `${(-y * 4).toFixed(2)}deg`);
        card.style.setProperty('--tilt-y', `${(x * 5).toFixed(2)}deg`);
        card.style.setProperty('--light-x', `${(x + 0.5) * 100}%`);
        card.style.setProperty('--light-y', `${(y + 0.5) * 100}%`);
      });
      card.addEventListener('mouseleave', () => {
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  }
})();
